'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bemReactCore = require('bem-react-core');

exports.default = (0, _bemReactCore.declMod)({ type: 'js' }, {
    block: 'b-statcounter',
    elem: 'gemius',
    willInit: function willInit() {
        this.state = {
            src: {
                ua: '//yandexgaua.hit.gemius.pl/xgemius.js',
                by: '//yandexgaby.hit.gemius.pl/xgemius.js'
            },
            tag: 'i'
        };
    },
    getCounterSrc: function getCounterSrc() {
        return '' + this.state.src[this.props.region];
    },
    didMount: function didMount() {
        var code = this.getCode();

        // Не дергаем счетчик, если не смогли получить код
        if (!code) {
            return;
        }

        if (window['pp_gemius_identifier']) {
            return;
        }

        window['pp_gemius_identifier'] = this.getCode();

        fetch(this.getCounterSrc()).then(function (res) {
            return res.text();
        }).then(function (scriptContent) {
            new Function(scriptContent)();
        });
    },

    // Атрибуты не нужны, т.к. вызываем счетчик через js
    attrs: null
});